import NextLink from "next/link";
import { Link as MuiLink, Button, ButtonProps } from "@material-ui/core";

interface ButtonLinkProps extends ButtonProps {
  route: string;
  target?: string;
  muiLinkStyle?: object;
}

export const ButtonLink = ({
  route,
  target,
  variant = "contained",
  color = "primary",
  muiLinkStyle = {},
  ...rest
}: ButtonLinkProps) => (
    <NextLink href={route} passHref>
      <MuiLink
        href=""
        target={target}
        underline="none"
        color="inherit"
        style={muiLinkStyle}
      >
        <Button variant={variant} color={color} onClick={() => {}} {...rest} />
      </MuiLink>
    </NextLink>
  );
